import { React } from "react";
import PageContainer from "../../components/PageContainer";
import PageHeaderContainer from "../../components/PageHeaderContainer";
import PageContentContainer from "../../components/PageContentContainer";
import BasicCardComponent from "../../components/BasicCard";
import CardComponent from "../../components/Card";
import ModalComponent from "../../components/Modal";
import ButtonComponent from "../../components/Button";
import DatePickerComponent from "../../components/DatePicker";
import { Code } from "../../components/Code";
import Toastify from "../../components/Toastify";
import { ContainerWithSidebar } from "../../components/ContainerWithSidebar";

import { AiOutlineIdcard } from "react-icons/ai";
import { DiReact } from "react-icons/di";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";

import { ContainerComponentsPageStyle } from "./style";

function Componentes({
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
  logOut,
}) {
  return (
    <ContainerWithSidebar
      increaseFontSize={increaseFontSize}
      decreaseFontSize={decreaseFontSize}
      HandledarkMode={HandledarkMode}
      isDarkMode={isDarkMode}
      logOut={logOut}
    >
      <PageContainer>
        <PageHeaderContainer title="Componentes" icon={<AiOutlineIdcard />} />
        <PageContentContainer>
          <ContainerComponentsPageStyle>
            <Row className="mb-3">
              <Col>
                <h2>Sidebar Desktop para telas a partir de 992px</h2>
                <hr />
                <Accordion>
                  <Accordion.Item  eventKey="0">
                    <Accordion.Header >React</Accordion.Header>
                    <Accordion.Body>
                      <Code>
                        {`import { React, useState } from "react";
import { useNavigate } from "react-router-dom";

import LogoT2m from "../../assets/img/logo_t2m.png";

import { AiOutlineTable, AiOutlineIdcard } from "react-icons/ai";
import { TbIcons } from "react-icons/tb";
import { HiOutlineColorSwatch } from "react-icons/hi";
import { FaWpforms } from "react-icons/fa";
import { BsArrowBarRight, BsArrowBarLeft } from "react-icons/bs";
import { CgHome } from "react-icons/cg";
import { MdOutlineExitToApp } from "react-icons/md";
import { BiUserCircle } from "react-icons/bi";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { SidebarStyle } from "./style.js";

function Sidebar({ logOut, windowSize }) {
  const [sideBarCollapse, setSideBarCollapse] = useState(true);
  const navigate = useNavigate();

  function navigateTo(route) {
    setSideBarCollapse(true);
    window.scrollTo(0, 0);
    navigate(route);
  }

  return (
    <Col className={windowSize >= 992 ? "px-0 col-1" : "px-0 col-0"}>
      <SidebarStyle collapse={sideBarCollapse}>
        <Row>
          <Col className="column-container">
            <div className="logo-area">
              <img src={LogoT2m} alt="Logo T2M" />
              {sideBarCollapse ? <span>SPL</span> : <span>Sistema de Padronização de Layouts</span>}              
            </div>
            <div className="collapse-sidebar-action">
              {sideBarCollapse ? (
                <BsArrowBarRight
                  title="Expandir"
                  onClick={() => setSideBarCollapse(!sideBarCollapse)}
                />
              ) : (
                <BsArrowBarLeft
                  title="Retrair"
                  onClick={() => setSideBarCollapse(!sideBarCollapse)}
                />
              )}
            </div>
            <div className="sidebar-nav">
              <div className="mt-2 sidebar-nav-item">
                <div onClick={() => navigateTo("/")}>
                  <div className="area-icons-label">
                    <CgHome title="Início" />
                    {sideBarCollapse ? (
                      ""
                    ) : (
                      <span className="label-sidebar">Início</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="sidebar-nav-item">
                <div onClick={() => navigateTo("/tabela")}>
                  <div className="area-icons-label">
                    <AiOutlineTable title="Tabela" />
                    {sideBarCollapse ? (
                      ""
                    ) : (
                      <span className="label-sidebar">Tabela</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="sidebar-nav-item">
                <div onClick={() => navigateTo("/cards")}>
                  <div className="area-icons-label">
                    <AiOutlineIdcard title="Componentes"/>
                    {sideBarCollapse ? (
                      ""
                    ) : (
                      <span className="label-sidebar">Componentes</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="sidebar-nav-item">
                <div onClick={() => navigateTo("/paletacores")}>
                  <div className="area-icons-label">
                    <HiOutlineColorSwatch title="Paleta de cores" />
                    {sideBarCollapse ? (
                      ""
                    ) : (
                      <span className="label-sidebar">Paleta de cores</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="sidebar-nav-item">
                <div onClick={() => navigateTo("/botoes")}>
                  <div className="area-icons-label">
                    <TbIcons title="Icones"/>
                    {sideBarCollapse ? (
                      ""
                    ) : (
                      <span className="label-sidebar">Icones</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="sidebar-nav-item">
                <div onClick={() => navigateTo("/formularios")}>
                  <div className="area-icons-label">
                    <FaWpforms title="Formulários"/>
                    {sideBarCollapse ? (
                      ""
                    ) : (
                      <span className="label-sidebar">Formulários</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="user-container">
              <BiUserCircle title="Larissa S."/>
              <div className="user-info">
                {sideBarCollapse ? (
                  ""
                ) : (
                  <span title="Larissa Santos" className="label-sidebar">
                    Larissa S.
                  </span>
                )}
                {sideBarCollapse ? (
                  ""
                ) : (
                  <span
                    id="user-department"
                    className="label-sidebar"
                    title="Departamento Pessoal"
                  >
                    Departamento pessoal
                  </span>
                )}
              </div>
            </div>
            <div className="sidebar-nav">
              <div className="sidebar-nav-item">
                <div onClick={() => logOut()}>
                  <div className="area-icons-label">
                    <MdOutlineExitToApp title="Sair"/>
                    {sideBarCollapse ? (
                      ""
                    ) : (
                      <span className="label-sidebar">Sair</span>
                    )}{" "}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </SidebarStyle>
    </Col>
  );
}

export default Sidebar;`}
                      </Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Styled Component</Accordion.Header>
                    <Accordion.Body>
                      <Code>
                        {`import styled from "styled-components";

export const SidebarStyle = styled.div\`
   
 
  font-size: 100%;
  margin: 0 !important;
  width: \${(props) => (props.collapse ? "7%" : "20%")};
  margin-top: 1rem !important;
  height: calc(100vh - 2rem);
  padding-top: 1rem;
  box-shadow: 1px 1px 5px var(--preto-primario);
  border-radius: 0rem 1rem 1rem 0rem;
  overflow: hidden;
  background-color: var(--branco);
  position: fixed;
  z-index: 9999;
  transition: 0.3s;

  .column-container {
    height: calc(100vh - 4rem);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    .collapse-sidebar-action {
      svg {
        font-size: 24px;
        &:hover {
          cursor: pointer;
          color: var(--verde-primario) !important;
        }
      }
    }

    .collapse-sidebar-action:hover {
      cursor: pointer;
    }

    .logo-area {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 1rem;
      background-color: var(--branco) !important;

      img {
        max-width: \${(props) => (props.collapse ? "70%" : "6rem")};
      }

      span{
        color: var(--verde-secundario);
        font-weight: bold;
        text-align: center;
      }
    }

    .sidebar-nav {
      display: flex;
      flex-direction: column;
      font-size: 1rem;
      align-items: \${(props) => (props.collapse ? "center" : "flex-start")};
      width: \${(props) => (props.collapse ? "auto" : "100%")};

      .sidebar-nav-item {
        width: \${(props) => (props.collapse ? "auto" : "100%")};
        padding: 0.5rem;
        transition: 0.3s;
        :hover {
          color: \${(props) =>
            props.collapse
              ? "var(--preto-primario) !important"
              : "var(--branco) !important"};
          background-color: \${(props) =>
            props.collapse ? "none" : "var(--verde-primario)"};
        }
      }

      .area-icons-label {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        &:hover {
          cursor: pointer;
        }
        svg {
          font-size: 24px;
          &:hover {
            color: \${(props) =>
              props.collapse
                ? "var(--verde-primario) !important"
                : "var(--branco) !important"};
          }
        }
      }
    }    

    .user-container {
      display: flex;
      align-items: center;
      justify-content: \${(props) =>
        props.collapse ? "center" : "space-around"};
      background-color: \${(props) =>
        props.collapse ? "var(--branco)" : "var(--verde-primario)"};
      color: var(--branco);
      padding: 0.4rem;
      width: 95%;
      border-radius: 5px;

      svg {
        font-size: 24px;
        color: \${(props) =>
          props.collapse ? "var(--preto-primario)" : "var(--branco)"};

        :hover {
          cursor: pointer;
          color: \${(props) =>
            props.collapse ? "var(--verde-primario) !important" : ""};
        }
      }

      .user-info {
        display: flex;
        flex-direction: column;
        font-size: 100%;
      }

      .user-info #user-department {
        font-size: 100%;
        font-weight: 200;
      }
    }
  } 
\`;`}
                      </Code>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h2>Sidebar Mobile para telas de até 991px</h2>
                <hr />
                <p>
                  Componente Bootstrap base{" "}
                  <a href="https://react-bootstrap.netlify.app/docs/components/offcanvas/#basic-example">
                    Sidebar Mobile
                  </a>
                </p>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>React</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Offcanvas from "react-bootstrap/Offcanvas";
import LogoT2m from "../../assets/img/logo_t2m.png";

import { AiOutlineTable, AiOutlineIdcard } from "react-icons/ai";
import { CgHome } from "react-icons/cg";
import { TbIcons } from "react-icons/tb";
import { HiOutlineColorSwatch } from "react-icons/hi";
import { FaWpforms } from "react-icons/fa";
import { BsArrowBarLeft } from "react-icons/bs";
import { CgMenuRound } from "react-icons/cg";
import { BiUserCircle } from "react-icons/bi";
import { MdOutlineExitToApp } from "react-icons/md";
import {
  SidebarMobileStyle,
  SidebarMobileNavStyle,
  LogoArea,
  CloseIconArea,
} from "./style.js";

function SidebarMobile({ logOut }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();

  function navigateTo(route) {
    setShow(false);
    window.scrollTo(0, 0);
    navigate(route);
  }

  return (
    <SidebarMobileStyle>
      <Row>
        <Col className="px-0 col">
          <div className="button-show-area">
            <div className="button-show">
              <CgMenuRound onClick={handleShow} />
            </div>
            <div className="central-area">
              <img src={LogoT2m} alt="Logo T2M" />
              <span>SPL</span>   
            </div>
            <div className="right-area">
              <BiUserCircle />
            </div>
          </div>
          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header>
              <Offcanvas.Title>
                <LogoArea>
                  <img src={LogoT2m} alt="Logo T2M" />
                  <span>Sistema de Padronização de Layouts</span> 
                </LogoArea>
              </Offcanvas.Title>
              <CloseIconArea>
                <BsArrowBarLeft onClick={handleClose} />
              </CloseIconArea>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <SidebarMobileNavStyle>
                <div className="flex-column sidebar-mobile-nav">
                  <div className="sidebar-nav-item">
                    <div onClick={() => navigateTo("/")}>
                      <div className="area-icons-label">
                        <CgHome />
                        <span>Início</span>
                      </div>
                    </div>
                  </div>
                  <div className="sidebar-nav-item">
                    <div onClick={() => navigateTo("/tabela")}>
                      <div className="area-icons-label">
                        <AiOutlineTable />
                        <span>Tabela</span>
                      </div>
                    </div>
                  </div>
                  <div className="sidebar-nav-item">
                    <div onClick={() => navigateTo("/cards")}>
                      <div className="area-icons-label">
                        <AiOutlineIdcard />
                        <span>Componentes</span>
                      </div>
                    </div>
                  </div>
                  <div className="sidebar-nav-item">
                    <div onClick={() => navigateTo("/paletacores")}>
                      <div className="area-icons-label">
                        <HiOutlineColorSwatch />
                        <span>Paleta de cores</span>
                      </div>
                    </div>
                  </div>
                  <div className="sidebar-nav-item">
                    <div onClick={() => navigateTo("/botoes")}>
                      <div className="area-icons-label">
                        <TbIcons />
                        <span>Icones</span>
                      </div>
                    </div>
                  </div>
                  <div className="sidebar-nav-item">
                    <div onClick={() => navigateTo("/formularios")}>
                      <div className="area-icons-label">
                        <FaWpforms />
                        <span>Formulários</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="user-container mt-3">
                  <BiUserCircle />
                  <div className="user-info">
                    <span title="Larissa Santos" className="label-sidebar">
                      Larissa S.
                    </span>
                    <span
                      id="user-department"
                      className="label-sidebar"
                      title="Departamento Pessoal"
                    >
                      Departamento pessoal
                    </span>
                  </div>
                </div>
                <div className="sidebar-mobile-nav">
                  <div className="sidebar-nav-item mt-3">
                    <div onClick={() => logOut()}>
                      <div className="area-icons-label">
                        <MdOutlineExitToApp />
                        <span>Sair</span>
                      </div>
                    </div>
                  </div>
                </div>
              </SidebarMobileNavStyle>
            </Offcanvas.Body>
          </Offcanvas>
        </Col>
      </Row>
    </SidebarMobileStyle>
  );
}

export default SidebarMobile;`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Styled Component</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import styled from "styled-components";

export const SidebarMobileNavStyle = styled.div\`
   

  font-size: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .collapse-sidebar-action {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .collapse-sidebar-action:hover {
    cursor: pointer;
  }

  .sidebar-mobile-nav {
    display: flex;
    gap: 1.2rem;

    .sidebar-nav-item {
      .area-icons-label {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        svg {
          font-size: 24px;
        }
      }
    }
  }

  .user-container {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: var(--verde-primario);
    color: var(--branco);
    padding: 0.4rem;
    width: 100%;
    border-radius: 5px;

    svg {
      font-size: 24px;
      color: var(--branco);
    }

    .user-info {
      display: flex;
      flex-direction: column;
      font-size: 100%;

      #user-department {
        font-size: 100%;
        font-weight: 200;
      }
    }
  }
\`;

export const LogoArea = styled.div\`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: 0.2rem;
  background-color: var(--branco) !important;

  img {
    width: 100%;
    max-width: 7rem;
  }

  span {
    color: var(--verde-secundario);
    font-weight: bold;
    text-align: center;    
  }
\`;

export const SidebarMobileStyle = styled.div\`
   

  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background-color: var(--branco) !important;
  z-index: 999;

  .button-show-area {
    padding: 1rem;
    box-shadow: 1px 1px 5px var(--preto-primario);
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    background-color: var(--branco) !important;

    .central-area {
      display: flex;

      justify-content: center;
      align-items: center;

      img {
        width: 5rem;
      }

      span {
        color: var(--verde-secundario);
        font-weight: bold;
        text-align: center;
        font-size: 1.8rem;
      }

      span::before {
        content: " - ";
      }
    }

    .right-area {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0.5rem;

      svg {
        font-size: 36px;
      }
    }

    .button-show {
      background-color: var(--branco) !important;
      width: 42px !important;
      svg {
        color: #444 !important;
        font-size: 36px;
        transition: 0.3s;

        &:hover {
          cursor: pointer;
          color: var(--verde-primario) !important;
        }
      }
    }
  }
\`;

export const CloseIconArea = styled.div\`
   

  svg {
    font-size: 24px !important;
    transition: 0.3s;

    &:hover {
      cursor: pointer;
      color: var(--verde-primario) !important;
    }
  }
\`;`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
            <Row>
              <Col>
                <CardComponent
                  title="Aviso!"
                  subTitle="Importante!"
                  bgColor="warning"
                  textColor="black"
                  size="100%"
                >
                  Abra o modo desenvolvedor de seu navegador (F12) e utilize o
                  emulador de dispositivos para visualizar a sidebar mobile
                  deste site.
                </CardComponent>
              </Col>
            </Row>
            <Row>
              <Col>
                <CardComponent
                  title="Informativo!"
                  subTitle="Atenção!"
                  bgColor="info"
                  textColor="white"
                  size="100%"
                >
                  Os ícones e navegações apresentadas nas sidebars tem o
                  objetivo de apresentar o layout. Os ícones e nomes devem ser
                  aptados conforme a necessidade de cada projeto.
                </CardComponent>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h2>Estrutura das Páginas</h2>
                <hr />
              </Col>
            </Row>
            <Row>
              <Col>
                <p style={{ lineHeight: "2.3rem" }}>
                  Para estruturar as páginas aplicando os estilos T2M deve ser
                  utilizado 3 componentes base,{" "}
                  <code className="code-container">{"<PageContainer/>"}</code>,{" "}
                  <code className="code-container">
                    {"<PageHeaderContainer/>"}
                  </code>
                  ,{" "}
                  <code className="code-container">
                    {"<PageContentContainer/>"}
                  </code>
                  .
                </p>
                <p style={{ lineHeight: "2.3rem" }}>
                  <code className="code-container">{"<PageContainer/>"}</code>{" "}
                  responsável por gerar o container de mais alto nível do
                  layout. E sua visualização em tela é assim:{" "}
                </p>
                <PageContainer> Hello World </PageContainer>
                <p className="p-2" style={{ lineHeight: "3rem" }}>
                  <code className="code-container">
                    {"<PageHeaderContainer/>"}
                  </code>{" "}
                  responsável por gerar o header de cada página. Esse componente
                  recebe dois parametros o <strong>"title"</strong> e o{" "}
                  <strong>"icon"</strong> que será exibido. Este componente deve
                  ser o primeiro elemento do componente{" "}
                  <code className="code-container">{"<PageContainer/>"}</code>.
                  Seguindo com o exemplo acima vamos incluir um header "Exemplo"
                  na nossa página "Hello World." A visualização ficará assim:
                </p>
                <PageContainer>
                  <PageHeaderContainer title="Exemplo" icon={<DiReact />} />
                  Hello World
                </PageContainer>
                <p style={{ lineHeight: "2.3rem" }}>
                  O ultimo componente a ser inserido é o{" "}
                  <code className="code-container">
                    {"<PageContentContainer/>"}
                  </code>{" "}
                  responsável por controlar o layout de todo o{" "}
                  <strong>conteúdo</strong> da página. Este componente deve ser
                  inserido após o componente{" "}
                  <code className="code-container">
                    {"<PageHeaderContainer/>"}
                  </code>
                  . O resultado final fica assim:
                </p>
                <PageContainer>
                  <PageHeaderContainer title="Exemplo" icon={<DiReact />} />
                  <PageContentContainer>Hello World</PageContentContainer>
                </PageContainer>
                <p>
                  Os Componentes ficaram aninhados dessa forma para gerar o
                  exemplo acima.
                </p>
                <Code>{`<PageContainer>
  <HeaderPageComponent title='Exemplo' icon={<DiReact />} />
  <ContentPageContainer>Hello World</ContentPageContainer>
</PageContainer>`}</Code>
                <p>
                  Abaixo os códigos e styled component de cada componente para
                  serem utilizados nos projetos.
                </p>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <Accordion className="mt-3">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>PageContainer - React</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import { React } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { PageContainerStyle } from "./style";

function PageContainer(props) {
  return (
    <PageContainerStyle>
      <Row>
        <Col className="col-12">{props.children}</Col>
      </Row>
    </PageContainerStyle>
  );
}

export default PageContainer;
`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      PageContainer - Styled Component
                    </Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import styled from "styled-components";

export const PageContainerStyle = styled.div\`
     

    width: 100%;    
    background-color: var(--branco);    
    border-radius: 1rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    box-shadow: 1px 1px 5px var(--preto-primario);
    overflow: hidden;
\`;`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      PageHeaderContainer - React
                    </Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import { React } from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { PageHeaderContainerStyle } from "./style";

function PageHeaderContainer({ title, icon }) {
  return (
    <Row>
      <Col>
        <PageHeaderContainerStyle>
          {icon}
          <span>{title}</span>
        </PageHeaderContainerStyle>
      </Col>
    </Row>
  );
}

export default PageHeaderContainer;
`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      PageHeaderContainer - Styled Component
                    </Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import styled from "styled-components";

export const PageHeaderContainerStyle = styled.div\`
     

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    background-color: var(--verde-secundario);
    color: var(--branco);   
    height: 100px;
    
    span{
        font-size: 2rem;        
    }

    svg{
        font-size: 48px;
    }
\`;`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      PageContentContainer - React
                    </Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import { React } from "react";
import {PageContentContainerStyle} from "./style";

function PageContentContainer(props) {
    return(
        <PageContentContainerStyle>
            {props.children}
        </PageContentContainerStyle>
    );
}

export default PageContentContainer;
`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      PageContentContainer - Styled Component
                    </Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import styled from "styled-components";

export const PageContentContainerStyle = styled.div\`
    p{
        text-align: left;
    }

    width: 100%;
    padding: 1.5rem;
\`;`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h2>Card Basico</h2>
                <hr />
                <p>
                  Componente Bootstrap base{" "}
                  <a href="https://react-bootstrap.netlify.app/docs/components/cards/#content-types">
                    Componente Card
                  </a>
                </p>
                <p>
                  Os cards devem possuir tamanhos padronizados. Os cards podem
                  ser modelos pequenos ou contemplar toda a extensão da página.
                </p>
                <p>Cards podem possuir icones ou links</p>
                <p>
                  <strong>Cards pequenos:</strong> width:'18rem'
                </p>
                <p>
                  <strong>Cards grandes:</strong> width:'100%'
                </p>
                <BasicCardComponent
                  title="Basic Card"
                  text="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's"
                  buttonAlternativeText="Delete Record"
                />
                <Accordion className="mt-3">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>React</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import Card from "react-bootstrap/Card";

import { RiDeleteBin6Line } from "react-icons/ri";
import { BasicCardStyle } from "./style";

function BasicCardComponent({ title, text, buttonAlternativeText, action }) {
  return (
    <BasicCardStyle>
      <Card>
        <Card.Body className="card-body d-flex justify-content-between align-items-center">
          <div>
            <Card.Title tabIndex={0}>{title}</Card.Title>
            <Card.Text tabIndex={0}>{text}</Card.Text>
          </div>
          <button
            role="button"
            aria-label={buttonAlternativeText}
            title={buttonAlternativeText}
            onClick={action}
          >
            <RiDeleteBin6Line />
          </button>
        </Card.Body>
      </Card>
    </BasicCardStyle>
  );
}

export default BasicCardComponent;
`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Styled Component</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import styled from "styled-components";

export const BasicCardStyle = styled.div\`
   

  > div {
    border-radius: 0.3rem !important;
    background-color: var(--verde-secundario);
    box-shadow: 1px 1px 5px var(--preto-primario);
    color: var(--branco);
    transition: 0.3s;

    .card-body {
      button {
        background-color: transparent !important;
        border: none !important;
        padding: 1rem;

        svg {
          color: var(--branco);
          font-size: 1.3rem;

          :hover {
            filter: brightness(0.8);
          }
        }
      }
    }
  }
\`;
`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h2>Card</h2>
                <hr />
                <p>
                  Componente Bootstrap base{" "}
                  <a href="https://react-bootstrap.netlify.app/docs/components/cards/#card-styles">
                    Card Style
                  </a>
                </p>
                <p>
                  Os cards devem possuir tamanhos padronizados. Os cards podem
                  ser modelos pequenos ou comtemplar toda a extensão da página.
                </p>
                <p>
                  <strong>Cards pequenos:</strong> width:'18rem'
                </p>
                <p>
                  <strong>Cards grandes:</strong> width:'100%'
                </p>
                <CardComponent
                  title="Header"
                  subTitle="Titulo"
                  bgColor="#01A998"
                  textColor="white"
                  size="18rem"
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </CardComponent>
                <CardComponent
                  title="Header"
                  subTitle="Titulo"
                  bgColor="#01A998"
                  textColor="white"
                  size="100%"
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </CardComponent>
              </Col>
            </Row>
            <Row>
              <Col>
                <h2>Accordion</h2>
                <hr />
                <p>
                  Componente Bootstrap base{" "}
                  <a href="https://react-bootstrap.netlify.app/docs/components/accordion/#basic-example">
                    Accorddion basic
                  </a>
                </p>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Accordion Item #1</Accordion.Header>
                    <Accordion.Body>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Accordion Item #2</Accordion.Header>
                    <Accordion.Body>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo consequat.
                      Duis aute irure dolor in reprehenderit in voluptate velit
                      esse cillum dolore eu fugiat nulla pariatur. Excepteur
                      sint occaecat cupidatat non proident, sunt in culpa qui
                      officia deserunt mollit anim id est laborum.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <h3 className="mb-3 mt-3">Customização de Estilo - T2M</h3>
                <Code>{` 

.accordion-button {
  outline: none !important;
  box-shadow: none !important;
  border: 0px !important;
}

.accordion-button:not(.collapsed) {
  background-color: var(--verde-primario) !important;
  background-image: none !important;
  color: var(--branco) !important;

  ::after {
    filter: invert(100%) !important;
  }
}`}</Code>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h2>Modal</h2>
                <hr />
                <p>
                  Componente Bootstrap base{" "}
                  <a href="https://react-bootstrap.netlify.app/docs/components/modal/#live-demo">
                    Modal
                  </a>
                </p>
                <ModalComponent />
              </Col>
            </Row>
            <Row className="mb-3 mt-3">
              <Col>
                <h2>Date Picker</h2>
                <hr />
                <p>
                  Documentação{" "}
                  <a href="https://www.npmjs.com/package/react-datepicker?activeTab=readme">
                    react-datepicker
                  </a>
                </p>
                <p className="mb-4 code-container">
                  <code>npm install react-datepicker --save</code>
                </p>
                <h3>Seleção de data completa</h3>
                <DatePickerComponent
                  startDate={Date.now()}
                  dateFormat="dd/MM/yyyy"
                  showMonthYearPicker={false}
                  showFullMonthYearPicker={false}
                  action={(date) => alert(`Foo... Data selecionada: ${date}`)}
                />
                <h3 className="mt-2">Seleção de mês e ano</h3>
                <DatePickerComponent
                  startDate={Date.now()}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker={true}
                  showFullMonthYearPicker={true}
                  action={(date) => alert(`Foo... Data selecionada: ${date}`)}
                />
              </Col>
            </Row>
            <Row className="mb-3 mt-3">
              <Col>
                <h2>Toastify</h2>
                <hr />
                <p>
                  Documentação{" "}
                  <a href="https://fkhadra.github.io/react-toastify/introduction/">
                    react-toastify
                  </a>
                </p>
                <p className="mb-4 code-container">
                  <code>npm install --save react-toastify</code>
                </p>
                <h3>Exemplos de Toastify</h3>
                <p>Clique nos botões para visualizar os modelos de toastify</p>
                <div className="d-flex justify-content-center flex-wrap gap-4 mb-4">
                  <Toastify type="success" />
                  <Toastify type="warning" />
                  <Toastify type="danger" />
                  <Toastify type="info" />
                </div>
                <Code>
                  {`/* Parametros de Layout Toast */
<ToastContainer
  position="top-right"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme="colored"
/>`}
                </Code>
              </Col>
            </Row>
            <Row>
              <Col className="mb-3 mt-3">
                <h2>Botões</h2>
                <hr />
                Componente bootstrap base:{" "}
                <a href="https://react-bootstrap.netlify.app/docs/components/buttons/#examples">
                  Botões bootstrap
                </a>
                <h3 className="mt-3">Tamanhos</h3>
                <hr />
                <p className="mt-3">
                  Os botões devem seguir um padrão de tamanho.
                </p>
                <p>
                  <strong>Botão padrão:</strong> width:'10rem'. <br /> Deve ser
                  aplicado em maior parte da aplicação. Ex. Formulários de
                  cadastro, edição de registros, modal entre outros cenários...
                </p>
                <ButtonComponent
                  size="10rem"
                  bgColor="#03A688"
                  textColor="#FFF"
                >
                  Sucesso
                </ButtonComponent>
                <p className="mt-3">
                  <strong>Botão grande:</strong> width:'18rem'
                </p>
                <ButtonComponent
                  size="18rem"
                  bgColor="#03A688"
                  textColor="#FFF"
                >
                  Sucesso
                </ButtonComponent>
                <p className="mt-3">
                  <strong>Botão gigante:</strong> width:'30rem'
                </p>
                <ButtonComponent
                  size="30rem"
                  bgColor="#03A688"
                  textColor="#FFF"
                >
                  Sucesso
                </ButtonComponent>
              </Col>
            </Row>
            <Row>
              <h3>Cores</h3>
              <hr />
              <p className="mt-3">
                Os botões devem seguir uma coloração condizente com sua
                finalidade.
              </p>
              <span className="mb-3">
                Algumas cores possuem nomenclatura <strong>variant</strong> por
                utilizar a cor padrão disponibilizada pelo bootstrap.
              </span>
              <Col className="mb-2">
                <ButtonComponent
                  size="10rem"
                  bgColor="#03A688"
                  textColor="#FFF"
                >
                  Sucesso
                </ButtonComponent>
                <span>Hexadecimal: #03A688</span>
              </Col>
              <Col className="mb-2">
                <ButtonComponent
                  size="10rem"
                  bgColor="#585859"
                  textColor="#FFF"
                >
                  Cancelar
                </ButtonComponent>
                <span>Hexadecimal: #585859</span>
              </Col>
              <Col className="mb-2">
                <ButtonComponent
                  size="10rem"
                  bgColor="warning"
                  textColor="#000"
                >
                  Editar
                </ButtonComponent>
                <span>variant: 'warning'</span>
                <br />
                <span>Hexadecimal: #ffca2c</span>
              </Col>
              <Col className="mb-2">
                <ButtonComponent
                  size="10rem"
                  bgColor="#fa5a54"
                  textColor="#FFF"
                >
                  Perigo
                </ButtonComponent>
                <span>Hexadecimal: #fa5a54</span>
              </Col>
              <Col className="mb-2">
                <ButtonComponent size="10rem" bgColor="info" textColor="#000">
                  Informativo
                </ButtonComponent>
                <span>variant: 'info'</span>
                <br />
                <span>Hexadecimal: #5bc0de</span>
              </Col>
            </Row>
            <Row>
              <Col>
                <Accordion className="mt-3">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>React</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import { React } from "react";
import Button from "react-bootstrap/Button";

import { ButtonStyle } from "./style";

function ButtonComponent({ size, bgColor, textColor, action, alternativeText, children }) {
  return (
    <ButtonStyle size={size} bgColor={bgColor} textColor={textColor}>
      <Button
        role="button"
        aria-label={alternativeText}
        title={alternativeText}
        variant={bgColor}
        className="botao-default"
        style={{ maxWidth: "100%" }}
        onClick={action}
      >
        {children}
      </Button>
    </ButtonStyle>
  );
}

export default ButtonComponent;
`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Styled Component</Accordion.Header>
                    <Accordion.Body>
                      <Code>{`import styled from "styled-components";

export const ButtonStyle = styled.div\`
    .botao-default{
        width:\${props => props.size} !important;
        background-color: \${props => props.bgColor} !important;
        color:\${props => props.textColor} !important;        
        border: none !important;
        transition: 0.3s;

        &:hover{
            filter: brightness(0.8);
        }
    }
\`;`}</Code>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
          </ContainerComponentsPageStyle>
        </PageContentContainer>
      </PageContainer>
    </ContainerWithSidebar>
  );
}

export default Componentes;
